module.exports = __webpack_public_path__ + "bc29f980c3ed546898a9305fac9ae1f4.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/users-shared-accounts/users-shared.html
// module id = 2615
// module chunks = 0